import { useCallback } from 'react';
import { useSelector } from 'react-redux';

/**
 * Resolves a DSO code to its display name against the `dsoNames` slice
 * `useAppBootstrap` loads for every route. A code with no name in the list —
 * or one resolved before the list has arrived — falls back to the code itself
 * rather than vanishing.
 *
 * Kept out of the components that render DSOs so those stay pure and testable
 * without a store; they take already-resolved names as props.
 */
export const useDsoNameResolver = () => {
  const dsoNames = useSelector((state) => state.users.dsoNames);

  return useCallback(
    (code) => (dsoNames ?? []).find((dso) => dso.code === code)?.name ?? code,
    [dsoNames],
  );
};

export default useDsoNameResolver;
